/* eslint-disable */
import React from 'react'
import http from '../Interceptor/Interseptor'
import {Checkbox, message} from 'antd'
import {Link} from 'react-router-dom'
import $ from 'jquery'
import FromToPicker from '../BaseComponent/FromToPicker'
import HeaderGrid from '../Pagination/HeaderGrid'
import SortLocal from '../BaseComponent/sortLocal'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import Select from 'react-select'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import {CopyToClipboard} from 'react-copy-to-clipboard'
import Loader from '../loaders/loader'
import {orderInfo, productShop} from '../../lib/path'
import jMoment from 'moment-jalaali'
import moment from 'moment-jalali'
import AutoComplete from '../BaseComponent/autocomplete'

class EditPreRecordAutomatic extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      buttonClicked: false,
      providers: [],
      providerId: '',
      products: [],
      productId: '',
      list: [],
      fromDate: '',
      toDate: '',
      items: [],
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        }
      ]
    }
  }

  submitForm(e) {
    e.preventDefault()
  }

  componentDidMount() {
    $(function() {
      $('.filterBtn').on('click', function() {
        $('.basketFilterComponent').slideToggle()
      })
    })

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')
  }

  getReport = () => {
    this.setState({loading: true})
    let filter = this.createFilter()
    http
      .get(`invoices/document/incompatibilities`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error === null) {
          $('.showBaseTable,.print').fadeIn()
          this.setState({
            list: response.data.object,
            loading: false
          })
        } else {
          $('.showBaseTable,.print').fadeOut()
          this.setState({
            listWareHouse: [],
            lengthList: 0,
            loading: false
          })
          // message.error('خطای ' + response.data.errorCode + ' : ' + response.data.description)
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        alert(JSON.stringify(error))
      })
  }

  getValueProvider = (providerId) => {
    if (!providerId) {
      this.setState({
        products: [],
        providerId: [],
        productId: ''
      })
    } else {
      this.setState({
        providerId
      })
      let id = providerId

      http
        .get(`${REPORT_RETAIL.REPORT_RETAIL_PRODUCT}?providerId=${id}&export=true&sortBy=productName_asc`, {})
        .then((response) => {
          if (response.data.error === null) {
            var products = response.data.object.result
            for (let i = 0; i < products.length; i++) {
              products[i]['value'] = products[i].productId
              products[i]['label'] = products[i].articleId + ' - ' + products[i].productName
            }
            this.setState({
              products: response.data.object.result
            })
          } else {
            this.setState({
              products: []
            })
          }
        })
    }
  }

  getValueProduct = (productId) => {
    if (productId === null) {
      this.setState({
        productId: ''
      })
      // sessionStorage.removeItem('productId')
    } else {
      // sessionStorage.setItem('productId',JSON.stringify(productId))
      this.setState({
        productId
      })
    }
  }

  handleChangeFromDate = (fromDate) => {
    this.setState({
      fromDate
    })
  }

  handleChangeToDate = (toDate) => {
    this.setState({
      toDate
    })
  }

  createFilter = () => {
    let filter = {}
    let providerId = this.state.providerId
    let stockProductId =
      this.state.productId == null || this.state.productId == '' ? '' : this.state.productId.stockProductId
    let fromTime = this.state.fromDate
    let toTime = this.state.toDate
    if (this.state.sortBy !== '') {
      filter.sortBy = this.state.sortBy
    }

    if (providerId) {
      filter.providerId = providerId
    }
    if (stockProductId !== '') {
      filter.stockProductId = stockProductId
    }

    if (fromTime !== '') {
      filter.fromTime = fromTime
    }
    if (toTime !== '') {
      filter.toTime = toTime
    }

    return filter
  }

  filter() {
    let {providerId, fromDate, toDate} = this.state
    const currentDate = this.epochFrom(this.convertDigit(jMoment().format('jYYYY/jMM/jDD')))
    if (providerId === '' || fromDate === '' || toDate === '') {
      message.error('فیلد های ستاره دار وارد شود')
    } else if (currentDate > fromDate) {
      message.error(`تاریخ از حداقل باید ${jMoment().format('jYYYY/jMM/jDD')} باشد`)
    } else {
      this.getReport()
    }
  }

  editAutomatic = () => {
    let list = this.state.list
    let providerId = this.state.providerId ? this.state.providerId : ''
    let fromTime = this.state.fromDate
    let toTime = this.state.toDate
    let suggestArray = []
    for (let i in list) {
      if (!(list[i].quantity - list[i].docQuantity < 0)) {
        suggestArray.push({
          stockProductId: list[i].stockProductId,
          quantity: list[i].quantity - list[i].docQuantity
        })
      }
    }
    if (suggestArray.length === 0) {
      message.error('تعداد موجودی از تعداد اقلام فاکتورها بیشتر است')
    } else {
      let data = {
        suggestList: suggestArray,
        providerId,
        fromTime,
        toTime
      }
      this.setState({loading: true})
      http.post(`invoices/edition/suggest`, data, {}).then((res) => {
        if (res.data.error === null) {
          this.setState({
            items: res.data.object,
            customerModal: true,
            loading: false
          })
        }
      })
    }
  }

  confirmEdit = () => {
    let {items} = this.state
    let providerId = this.state.providerId ? this.state.providerId : ''
    let stockProductId =
      this.state.productId == null || this.state.productId == '' ? '' : this.state.productId.stockProductId
    let fromTime = this.state.fromDate
    let toTime = this.state.toDate
    let confirms = []
    for (let i in items) {
      confirms.push({
        invoiceItemId: items[i].invoiceItemId,
        quantity: items[i].quantityAfterEdition
      })
    }
    let data = {
      editionList: confirms,
      fromTime,
      toTime,
      providerId,
      stockProductId: stockProductId === '' ? undefined : stockProductId
    }
    console.log(data)
    this.setState({loading: true})

    // alert(JSON.stringify(data))
    http.post(`invoices/edition/accept`, data, {}).then((res) => {
      if (res.data.error === null) {
        message.success('با موفقیت انجام شد')
        this.setState({
          customerModal: false,
          loading: false,
          successCount: res.data.object.successCount,
          failedCount: res.data.object.failedCount,
          showResultModal: true
        })
        this.getReport()
      }
    })
  }

  epochFrom = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)

      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let from = miladiDate + ' ' + '00:00'
      console.log(from)
      let fromEpoch = moment.utc(from).valueOf()
      if (n >= 0) {
        return fromEpoch - 3.5 * 3600 * 1000
      } else if (n < 0 && concatDate === '0101') {
        return fromEpoch - 3.5 * 3600 * 1000
      } else {
        return fromEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  epochTo = (x) => {
    if (
      x.match(
        /^[1-4]\d{3}\/((0[1-6]\/((3[0-1])|([1-2][0-9])|(0[1-9])))|((1[0-2]|(0[7-9]))\/(30|([1-2][0-9])|(0[1-9]))))$/
      )
    ) {
      var concatDayMount = x.split('/')
      var concatDate = concatDayMount[1] + concatDayMount[2]
      var constantDate = '0631'
      var n = concatDate.localeCompare(constantDate)

      let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
      let to = miladiDate + ' ' + '23:59:59'
      let toEpoch = moment.utc(to).valueOf()
      if (n >= 0) {
        return toEpoch - 3.5 * 3600 * 1000
      } else if (n < 0 && concatDate === '0101') {
        return toEpoch - 3.5 * 3600 * 1000
      } else {
        return toEpoch - 3.5 * 3600 * 1000
      }
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  render() {
    return (
      <div className="rtl">
        <Loader show={this.state.loading} />

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>توزیع</li>
            <li>ویرایش فاکتورها</li>
            <li>مغایرت موجودی و فاکتور ها</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} />
                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
              </div>
            </div>
            <div className="basketFilterComponent">
              <div className="filterInputs">
                <div className="formComponent selectComponent">
                  <AutoComplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    required
                    value={this.state.providerId}
                    setValue={this.getValueProvider}
                  />

                  {/* <label className={'font-weight-bold'}>تامین کننده <span className='requireFiled'>*</span></label>
                                    <Select
                                        options={this.state.providers}
                                        isClearable={true}
                                        placeholder={'------'}
                                        value={this.state.providerId}
                                        onChange={this.getValueProvider}
                                    /> */}
                </div>
                <div className="formComponent">
                  <label className={'font-weight-bold'}>{'کالا'}</label>
                  <Select
                    options={this.state.products}
                    isClearable={true}
                    placeholder={'------'}
                    value={this.state.productId}
                    onChange={this.getValueProduct}
                  />
                </div>

                <FromToPicker
                  onChangeFromDate={this.handleChangeFromDate}
                  onChangeToDate={this.handleChangeToDate}
                  fromLabel="تاریخ از"
                  toLabel="تاریخ تا"
                  fromId="from"
                  toId="to"
                  defaulValue
                  force
                />
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <div className="showBaseTable print">
              <table className="baseTable">
                <thead>
                  <tr>
                    <th>ردیف</th>
                    <th>عنوان</th>
                    <th>کد</th>
                    <th>تعداد در فاکتور</th>
                    <th>تعداد اقلام موجود</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.list.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <a target="_blank" href={productShop({articleId: item.articleId})}>
                          {item.title}
                        </a>
                      </td>
                      <td>{item.articleId}</td>
                      <td>{item.quantity}</td>
                      <td>{item.docQuantity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <hr />
              <div>
                <button className="confirmFilter" onClick={this.editAutomatic}>
                  ویرایش اتومات
                </button>
              </div>
            </div>
          </div>
        </div>
        <Modal isOpen={this.state.customerModal} toggle={() => this.setState({customerModal: false})} size="lg">
          <ModalHeader toggle={() => this.setState({customerModal: false})}>لیست فاکتور ها</ModalHeader>
          <ModalBody>
            {/*<Loader show={this.state.loading} />*/}

            <div className="unMatchClass">
              <table className="baseTable">
                <tbody>
                  <tr className="firstRow">
                    <td>ردیف</td>
                    <td>مشتری</td>
                    <td>شماره فاکتور</td>
                    <td>نام کالا در فاکتور</td>
                    <td>تعداد سفارش</td>
                    <td>تعداد پس از ویرایش</td>
                  </tr>
                  {this.state.items.map((item, index) => (
                    <tr key={index}>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {index + 1}
                      </td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {item.firstName + ' ' + item.lastName}
                      </td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        <a target="_blank" href={orderInfo({orderId: item.invoiceId})}>
                          {item.invoiceNum}
                        </a>
                      </td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {item.itemName}
                      </td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {item.quantity}
                      </td>
                      <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                        {item.quantityAfterEdition}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="titleSm">
              <Checkbox
                className="form-check"
                name="confirmCheck"
                checked={this.state.confirmCheck}
                onChange={() => this.setState({confirmCheck: !this.state.confirmCheck})}
              >
                از تایید نهایی مطمئن هستم
              </Checkbox>
            </p>
          </ModalBody>
          <ModalFooter>
            <button
              disabled={this.state.confirmCheck ? false : true}
              className={this.state.confirmCheck ? 'confirmBtnModal' : 'cancelBtnModal'}
              onClick={this.confirmEdit}
            >
              تایید نهایی
            </button>
            <button className="cancelBtnModal" onClick={() => this.setState({customerModal: false})}>
              لغو
            </button>
          </ModalFooter>
        </Modal>

        <Modal isOpen={this.state.showResultModal} toggle={() => this.setState({showResultModal: false})} size="sm">
          <ModalHeader toggle={() => this.setState({showResultModal: false})}>نتیجه ویرایش فاکتورها</ModalHeader>
          <ModalBody>
            {/*<Loader show={this.state.loading} />*/}

            <div className="d-flex flex-row flex-nowrap align-items-center align-content-center">
              <img src={require('../../image/confirm.svg')} width={50} />
              <p style={{fontSize: '1.2em'}} className="mx-2 mt-3">
                <span>تعداد فاکتور ویرایش شده : </span>
                <span className="font-weight-bold text-success">{this.state.successCount}</span>
              </p>
            </div>
            <hr />
            <div className="d-flex flex-row flex-nowrap align-item-center align-content-center">
              <img src={require('../../image/ignor.svg')} width={50} />
              <p style={{fontSize: '1.2em'}} className="mx-2 mt-3">
                <span>تعداد فاکتور ویرایش نشده : </span>
                <span className="font-weight-bold text-danger">{this.state.failedCount}</span>
              </p>
            </div>
          </ModalBody>
          <ModalFooter>
            <button className="cancelBtnModal" onClick={() => this.setState({showResultModal: false})}>
              بستن
            </button>
          </ModalFooter>
        </Modal>
      </div>
    )
  }
}

export default EditPreRecordAutomatic
